module.exports = __webpack_public_path__ + "img/fig08.b703c961.jpg";